export const references = [
    {
        slug: 'aesop-edgehill',
        store: {
            name: 'Edgehill',
            slug: 'edgehill'
        },
        category: {
            name: 'Photography',
            slug: 'photography'
        },
        tags: [
            {
                name: 'Aggregate',
                slug: 'aggregate'
            },
        ],
        year: '2017',
        images: [
            {
                thumbnail: 'https://storedesign.aesop.com/api/wp-content/uploads/2017/11/Large-JPG-Aesop-AU-Store-QV-05.jpg'
            },
            {
                thumbnail: 'https://storedesign.aesop.com/api/wp-content/uploads/2017/11/Large-JPG-Aesop-AU-Store-QV-05.jpg'
            }
        ],
        caption: 'Ciguë'
    },
    {
        slug: 'aesop-edgehill',
        store: {
            name: 'Edgehill',
            slug: 'edgehill'
        },
        category: {
            name: 'Photography',
            slug: 'photography'
        },
        tags: [
            {
                name: 'Aggregate',
                slug: 'aggregate'
            },
        ],
        year: '2017',
        images: [
            {
                thumbnail: 'https://storedesign.aesop.com/api/wp-content/uploads/2017/11/Large-JPG-Aesop-AU-Store-QV-05.jpg'
            }
        ],
        caption: 'Ciguë'
    },
    {
        slug: 'aesop-edgehill',
        store: {
            name: 'Flinders Street',
            slug: 'flinders-street'
        },
        category: {
            name: 'Photography',
            slug: 'photography'
        },
        tags: [
            {
                name: 'Aggregate',
                slug: 'aggregate'
            },
        ],
        year: '2017',
        images: [
            {
                thumbnail: 'https://storedesign.aesop.com/api/wp-content/uploads/2017/11/Large-JPG-Aesop-AU-Store-QV-05.jpg'
            }
        ],
        caption: 'Ciguë'
    },
]


// WEBPACK FOOTER //
// ./client/data/references.js